<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import VerticalDotsButton from "@/components/buttons/VerticalDotsButton.vue";
import TooltipButton from "@/components/buttons/TooltipButton.vue";
import { useReplaceTruck } from "@/composables";
import type { TripOverviewRoute } from "@/api/trips/dto/trip.dto";
import type { DisableRule } from "@/types/validation";

const { t } = useI18n();
const { createReplaceTruckDisableRules } = useReplaceTruck();

const props = defineProps<{
  route: TripOverviewRoute;
}>();

defineModel<boolean>("showReplaceTruckDialog", { default: false });
defineModel<boolean>("showRateConfirmationDialog", { default: false });

const emits = defineEmits<{
  (e: "update:showReplaceTruckDialog", value: boolean): void;
  (e: "update:showRateConfirmationDialog", value: boolean): void;
}>();

const replaceTruckDisableRules = computed<DisableRule[]>(() => createReplaceTruckDisableRules(props.route));
</script>

<template>
  <v-menu>
    <template #activator="{ props: menuProps }">
      <vertical-dots-button v-bind="menuProps" />
    </template>

    <v-list>
      <tooltip-button :rules="replaceTruckDisableRules" location="top left">
        <template #default="{ disabled }">
          <v-list-item :disabled="disabled" @click="emits('update:showReplaceTruckDialog', true)">
            <v-list-item-title>{{ t("trucks.replace-truck") }}</v-list-item-title>
          </v-list-item>
        </template>
      </tooltip-button>

      <v-list-item @click="emits('update:showRateConfirmationDialog', true)">
        <v-list-item-title>{{ t("trip.generate-rate-confirmation") }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
